'use client';

import { Checkbox } from '@lichtblick/photon/molecules/checkbox';
import { type PropsWithChildren, useState } from 'react';

type ElectricityCheckboxProps = PropsWithChildren & {
  defaultChecked?: boolean;
};

export const ElectricityCheckbox: React.FC<ElectricityCheckboxProps> = ({ children, defaultChecked }) => {
  const [isChecked, setIsChecked] = useState(defaultChecked || false);

  return (
    <>
      <Checkbox label={<Checkbox.Label>ÖkoStrom* hinzufügen</Checkbox.Label>}>
        <Checkbox.Checkbox
          data-testid="checkbox-electricity"
          defaultChecked={isChecked}
          name="combo-electricity"
          onChange={(e) => {
            setIsChecked(e.target.checked);
          }}
        />
      </Checkbox>

      {isChecked && children}
    </>
  );
};
